/** Universal gas constant, J/(kmol·K), as listed in the symbols of B.1 and C.1. (MD-011) */
export const R = 8314.5;
/** Atmospheric pressure, Pa (B.1). */
export const P_ATM = 101_325;
/** 20 °C in kelvin. The standard's examples compute gas density at 293.15 K. */
export const T_20C = 293.15;
/** Bumped whenever a change can alter a result. Stored with issued revisions. */
export const ENGINE_VERSION = '0.1.0';
